import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { WhatsIncluded } from './components/WhatsIncluded';
import { HowItWorks } from './components/HowItWorks';
import { BonusSection } from './components/BonusSection';
import { Testimonials } from './components/Testimonials';
import { PricingCTA } from './components/PricingCTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
const META_PIXEL_ID = '107007624422187';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // If pixel already loaded, just track PageView
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    // Initialize Meta Pixel
    const n: any = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    window.fbq = n;
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript?.parentNode?.insertBefore(script, firstScript);
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-cream font-inter text-navy selection:bg-gold selection:text-navy-dark" data-id="element-0">
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" />
      </noscript>
      <Hero data-id="element-3" />
      <PainSection data-id="element-4" />
      <WhatsIncluded data-id="element-5" />
      <HowItWorks data-id="element-6" />
      <BonusSection data-id="element-7" />
      <Testimonials data-id="element-8" />
      <PricingCTA data-id="element-9" />
      <FAQ data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}